module.exports = __webpack_public_path__ + "img/down-chevron.409656f0.svg";